/**
 * The initial value of Symbol.asyncIterator is the well known symbol @@asyncIterator
 * https://tc39.es/ecma262/#sec-symbol.asynciterator
 */
export const symbolAsyncIterator = () => Symbol("Symbol.asyncIterator");
